import { PayrollRun } from "@wingspanhq/wingspan-api-sdk";

/**
 * When a contractor run's money is expected to land, which is what v1's
 * "Expected pay date" tile showed.
 *
 * `payDate` is when the run is scheduled to be paid; it does not move when
 * settlement does, so it answers a different question. PLA-3612 added
 * `events.estimatedDepositAt` — the settlement estimate the funding invoice
 * produced, and the same value each of the run's payables inherits — so prefer
 * it and fall back to the scheduled date on a run that predates it or has not
 * been funded yet.
 */
export const selectorPayrollRunExpectedPayDate = (
  payrollRun?: PayrollRun
): Date | undefined =>
  payrollRun?.events?.estimatedDepositAt ?? payrollRun?.payDate ?? undefined;
